<template>
  <div class="form-group" :class="{ 'has-error': errors.has(fieldId, scope) }">
    <label v-if="label">{{ label }}</label>
    <input :type="type"
           :name="fieldId"
           :placeholder="placeholder"
           :id="fieldId"
           :value="value"
           @input="updateValue($event.target.value)"
           :maxlength="maxlength"
           class="form-control"
           :class="cssClass"
           v-validate="validation"
           data-vv-value-path="value"
           data-vv-validate-on="input" />
    <p class="text-danger" v-if="errors.has(fieldId, scope)">{{ errors.first(fieldId, scope) }}</p>
  </div>
</template>
<script>
  export default {
    inject: ['$validator'],
    props: {
      value: {
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      label: {
        type: String,
        required: false
      },
      placeholder: {
        type: String,
        default: ''
      },
      cssClass: {
        type: String,
        required: false
      },
      fieldId: {
        type: String,
        required: true
      },
      scope: {
        type: String,
        required: false
      },
      maxlength: {
        type: Number,
        required: false,
        default() {
          return 100000;
        }
      },
      validation: {
        type: String
      },
      required: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/form/textField.vue